if (!customElements.get('dd-protection-toggle')) {
  customElements.define('dd-protection-toggle', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.error = this.querySelector('[data-protection-error]');
      this.controller?.abort();
      this.controller = new AbortController();
      this.input.disabled = false;
      this.input.addEventListener('change', () => this.change(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async request(path, body) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + path, body ? {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      } : { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || this.dataset.error);
      return data;
    }

    async change() {
      if (this.busy) return;
      this.busy = true;
      this.input.disabled = true;
      this.error.hidden = true;
      const desired = this.input.checked;
      let present = !desired;
      try {
        const cart = await this.request('cart.js');
        const lines = cart.items.filter(item => String(item.product_id) === this.dataset.productId);
        present = lines.length > 0;
        if (present === desired) return;
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer.getSectionsToRender().map(section => section.id);
        const context = { sections, sections_url: window.location.pathname };
        let data;
        if (desired) {
          data = await this.request('cart/add.js', {
            ...context, items: [{ id: Number(this.dataset.variantId), quantity: 1 }]
          });
        } else {
          const updates = Object.fromEntries(lines.map(item => [item.key, 0]));
          data = await this.request('cart/update.js', { ...context, updates });
        }
        present = desired;
        if (!sections.every(id => typeof data.sections?.[id] === 'string')) {
          data.sections = await this.request('cart?sections=' + encodeURIComponent(sections.join(',')));
        }
        if (!sections.every(id => typeof data.sections?.[id] === 'string')) throw new Error(this.dataset.error);
        drawer.classList.toggle('is-empty', data.item_count === 0);
        drawer.renderContents(data);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data, variantId: this.dataset.variantId });
      } catch (error) {
        try {
          const cart = await this.request('cart.js');
          present = cart.items.some(item => String(item.product_id) === this.dataset.productId);
        } catch (_) {}
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.input.checked = present;
        this.input.disabled = false;
        this.busy = false;
      }
    }
  });
}
